export default __webpack_public_path__ + "static/how-nomba-qr-works-8214f291e981b883d5e6f0c79996ce6e.webm";